import React from "react";
import { cn } from "@/lib/utils";
import Wrapper from "./wrapper";

export interface ResponsiveProperties {
  sm?: string;
  md?: string;
  lg?: string;
}

interface ResponsiveWrapperProperties
  extends ResponsiveProperties,
    React.ComponentPropsWithoutRef<"div"> {
  className?: string;
  children: React.ReactElement<{ className?: string }>;
}

function ResponsiveWrapper({
  sm,
  md,
  lg,
  className = "",
  children,
  ...properties
}: ResponsiveWrapperProperties) {
  const responsiveClasses = cn(sm && sm, md && md, lg && lg, className);

  if (!React.isValidElement(children)) {
    throw new Error(
      "ResponsiveWrapper only accepts a single valid React element as its child.",
    );
  }

  return (
    <Wrapper asChild className={responsiveClasses} {...properties}>
      {children}
    </Wrapper>
  );
}

export default ResponsiveWrapper;
